import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import Slider from 'react-slick';
import Lottie from 'lottie-react';
import SiderNavigation from '../../slider/slider-navigation';
import ProjectBlurb from '../project-blurb';
import '../../../utils/slick-slider-styles/slick-main.css';
import { css } from 'emotion';
import styles from './slider.module.css';

import twentyTwentyJSON from './lotties/timeline-2020.json';
import twentySeventeenJSON from './lotties/timeline-2017.json';
import twentySevenJSON from './lotties/timeline-2007.json';
import ninetySixtyNineJSON from './lotties/timeline-1969.json';

const TwentyTwenty = () => <Lottie animationData={twentyTwentyJSON} />;
const TwentySeventeen = () => <Lottie animationData={twentySeventeenJSON} />;
const TwentySeven = () => <Lottie animationData={twentySevenJSON} />;
const NinetySixtyNine = () => <Lottie animationData={ninetySixtyNineJSON} />;

class ProjectSliderWeichert extends Component {
  constructor() {
    super();
    this.state = {
      activeSlide: 0,
    };
  }

  prevSlide = () => {
    this.slider.slickPrev();
  };
  nextSlide = () => {
    this.slider.slickNext();
  };

  render() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      afterChange: current =>
        this.setState({
          activeSlide: current,
        }),
    };

    const { slides, animation, wrapperPadding, blurb } = this.props;

    return (
      <div
        className={css`
          background: #fff;
          width: 100vw;
          position: relative;
          left: 50%;
          right: 50%;
          margin-left: -50vw;
          margin-right: -50vw;
          padding: ${wrapperPadding[1]};
          @media (min-width: 415px) {
            padding: ${wrapperPadding[0]};
          }
        `}
        style={animation}
      >
        <div className={styles.container}>
          {slides && (
            <div className={styles.wrapper}>
              <Slider ref={slider => (this.slider = slider)} {...settings}>
                <TwentyTwenty />
                <TwentySeventeen />
                <TwentySeven />
                <NinetySixtyNine />
              </Slider>
              <SiderNavigation
                prevSlide={this.prevSlide}
                nextSlide={this.nextSlide}
                sliderLength={4}
                activeSlide={this.state.activeSlide}
                navType={''}
                navPos={0}
                color={'#87878A'}
              />
            </div>
          )}
          <ProjectBlurb blurb={blurb} />
        </div>
      </div>
    );
  }
}

ProjectSliderWeichert.propTypes = {
  slides: PropTypes.array,
  animation: PropTypes.object,
  wrapperPadding: PropTypes.array,
  blurb: PropTypes.string,
};

export default ProjectSliderWeichert;



// WEBPACK FOOTER //
// ./src/components/project/project-slider-weichert/index.js